<script>
import Draggable from 'vuedraggable'
import ViewTitle from '@/components/ViewTitle'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import VueEditor from '@/components/vue2-editor/VueEditor'
import ViewDescription from '@/components/ViewDescription'
import Button from '@/components/Button'
import UsefulInfosServices from '@/services/usefulInfo'
import EnvironmentUtils from '@/utils/environmentUtils'
import VueUtils from '@/utils/vueUtils'
import StringUtils from '@/utils/stringUtils'
import DialogUtils from '@/utils/dialogUtils'

export default
{
    name: 'edit-useful-info',

    created ()
    {
        UsefulInfosServices.fetchInfos(EnvironmentUtils.cityId).then(infos  =>
        {
            this.$store.commit('usefulInfos/updateInfoList', infos)
            this.originalInfos = VueUtils.getObserverless(this.infos)
        })
    },

    render () 
    {
        const createInfoElement = (info, idx) =>
        {
            const el =
            <div class={`element ${this.infoBeingEditedId == info.id ? 'is-being-edited' : ''}`} key={idx}>
                <div class='header' on-click={() => this.onInfoClicked(el, info)}>
                    <div class='info-name'>{ info.title || 'Nouvelle information' }</div>
                    <inline-svg class='handle' src={require('@/assets/img/drag-handle.svg')} />
                </div>
                <div class='edition'>
                    <floating-label-text-input placeholder='Le titre de votre information' v-model={info.title} />
                    <vue-editor placeholder='Entrer ici la description de votre information utile.' v-model={info.description} />
                    <Button v-show={this.infosHavingBeenModified.includes(info.id)} type='primary' text='Sauvegarder les modifications' on-click={(e, b) => this.onInfoSaveClicked(el, info, e, b)} />
                    <Button type='danger' outlined={true} text='Supprimer cette information' on-click={(e, b) => this.onInfoDeleteClicked(el, info, e, b)} />
                </div>
            </div>

            return el
        }

        return (
            <div id='edit-useful-info-view'>
                <div class='header'>
                    <view-title>Éditer les informations utiles</view-title>
                    <view-description>
                        Vous pouvez définir l'ordre de vos informations utiles en glissant-déposant chaque élément. Cliquer pour éditer.
                    </view-description>
                </div>
                <Button id='add-info-btn' type='secondary' text='ajouter une information utile' icon={require('@/assets/img/plus.svg')} on-click={this.onAddInformationClicked} />
                <draggable class='info-list' handle='.handle' on-end={this.onListElementMoved} v-model={this.$store.state.usefulInfos.infoList}>
                    <transition-group>
                        { this.infos.map(createInfoElement) }
                    </transition-group>
                </draggable>
            </div>
        )
    },

    data () 
    {
        return {
            originalInfos: [],
            infoBeingEditedId: undefined,
            infosHavingBeenModified: []
        }
    },

    mounted ()
    {
    },

    computed:
    {
        infos ()
        {
            return this.$store.state.usefulInfos.infoList
        }
    },

    watch:
    {
        infos:
        {
            handler (val)
            {
                for (const info of this.infos)
                {
                    const original = this.originalInfos.find(i => i.id == info.id)

                    var hasBeenModified = false
                    if (original)
                    {
                        const descriptionModified = info.description != original.description
                        hasBeenModified = info.title != original.title || descriptionModified
                    }
                    else hasBeenModified = true

                    if (hasBeenModified && !this.infosHavingBeenModified.includes(info.id)) this.infosHavingBeenModified.push(info.id)
                    else if (!hasBeenModified) this.infosHavingBeenModified = this.infosHavingBeenModified.filter(id => id != info.id)
                }

            },
            deep: true
        }
    },

    methods:
    {
        onListElementMoved (event)
        {
            console.log('Updating infos order')
            this.$ga.event('useful_info', 'update:moved', this.$store.state.user.username)

            const updatedInfos = []

            for (const info of this.infos)
            {
                const updatedInfo = {}
                updatedInfo.id = info.id
                updatedInfo.orderId = this.infos.indexOf(info)

                updatedInfos.push(updatedInfo)
            }

            this.sendUpdateInfosRequest(updatedInfos)

            return true
        },

        onInfoClicked (element, info)
        {
            console.log('Info element', element, 'with info', info, 'clicked')
            this.$ga.event('useful_info', 'click:info', this.$store.state.user.username, info.id)

            if (this.infoBeingEditedId == info.id) this.infoBeingEditedId = undefined
            else this.infoBeingEditedId = info.id
        },

        async onInfoSaveClicked (element, info, event, button)
        {
            this.$ga.event('useful_info', 'click:save_info', this.$store.state.user.username, info.id)

            if (StringUtils.isEmptyString(StringUtils.removeHtmlTags(info.title)))
                return this.$toast.warning('Votre information utile doit avoir un titre')
            if (StringUtils.isEmptyString(StringUtils.removeHtmlTags(info.description)))
                return this.$toast.warning('Votre information utile doit avoir une description')

            button.showSpinner = true

            console.log('Saving info', info.id, info)
            if (info.isUncreated)
            {
                console.log('Info is not created, creating it...')
                await this.sendCreateInfoRequest(info)
            }
            else await this.sendUpdateInfosRequest([info])

            button.showSpinner = false
        },

        async onAddInformationClicked (event, button)
        {
            button.showSpinner = true

            const newInfo = { id: -Math.floor(Math.random() * 10000), isUncreated: true }
            this.infoBeingEditedId = newInfo.id
            
            await this.$store.commit('usefulInfos/updateInfoList', [newInfo])

            button.showSpinner = false
        },

        async onInfoDeleteClicked (element, info, event, button)
        {
            this.$ga.event('useful_info', 'click:delete_info', this.$store.state.user.username, info.id)

            const confirm = await DialogUtils.waitForUserConfirmationAsync()
            if (!confirm) return

            button.showSpinner = true

            await this.deleteInfo(info)
            
            button.showSpinner = false
        },

        async deleteInfo (info)
        {
            this.$ga.event('useful_info', 'delete', this.$store.state.user.username, info.id)

            if (!info.isUncreated)
            {
                await UsefulInfosServices.deleteInfo(info.id, EnvironmentUtils.cityId, this.$store.state.user.token)
            }

            await this.$store.dispatch('usefulInfos/removeInfoById', info.id)
        },

        async sendUpdateInfosRequest (infos)
        {
            console.log('Sending useful infos update request with data', infos)
            this.$ga.event('useful_info', 'update', this.$store.state.user.username, infos.length > 0 ? infos[0].id : undefined)

            const res = await UsefulInfosServices.updateInfos(infos, EnvironmentUtils.cityId, this.$store.state.user.token)
            this.originalInfos = VueUtils.getObserverless(this.infos)
            await this.$store.commit('usefulInfos/updateInfoList', res)

            console.log('Useful infos updated', res)
        },

        async sendCreateInfoRequest (info)
        {
            console.log('Sending useful infos create request with data', info)

            const addedInfo = await UsefulInfosServices.createInfo(info, EnvironmentUtils.cityId, this.$store.state.user.token)
            this.deleteInfo(info)
            this.originalInfos = VueUtils.getObserverless(this.infos)
            await this.$store.commit('usefulInfos/updateInfoList', [addedInfo])
            this.$ga.event('useful_info', 'create', this.$store.state.user.username, addedInfo.id)
        }
    },

    components:
    {
        ViewTitle,
        ViewDescription,
        Draggable,
        FloatingLabelTextInput,
        VueEditor,
        Button
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#edit-useful-info-view
{
    margin-top: calc(var(--theme-status-bar-height) + 6vw);
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 4vh);
    margin-left: 3vw;
    margin-right: 3vw;

    .OnTablet({
        margin-left: 8vw;
        margin-right: 8vw;
    });

    .OnDesktop({
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
        padding-left: 12vw;
        padding-right: 12vw;
        margin-top: 4vw;
    });

    > .header
    {
        margin-left: 3vw;

        .OnDesktop({ margin-left: 1vw; });
    }

    > #add-info-btn
    {
        width: -webkit-fill-available;
        margin-bottom: 6vw;
        margin: 3vw;

        .OnTablet({
            margin: 2vw;
            margin-bottom: 4vw;
        });
        .OnDesktop({
            margin: 1vw;
            margin-bottom: 4vh;
        });
    }

    .info-list
    {
        .element
        {
            background-color: var(--theme-content-background-color);
            border-radius: 6px;
            padding: 5vw;
            margin: 3vw;

            .OnTablet({
                padding: 3vw;
                margin: 2vw;
            });
            .OnDesktop({
                padding: 1.8vh;
                margin: 1.5vh;
            });

            &.is-being-edited
            {
                .edition
                {
                    display: inherit;
                }

                .header
                {
                    .OnDesktop({ padding-top: 1vh; });
                }
            }
            
            > .header
            {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-left: 2vw;
                margin-right: 2vw;
                cursor: pointer;

                > .info-name
                {
                    font-weight: 500;
                }

                > .handle
                {
                    fill: var(--theme-text-color-light);
                    .WidthHeight(6vw);

                    .OnTablet({ .WidthHeight(3.5vw); });
                    .OnDesktop({ .WidthHeight(2.5vh); });
                }
            }

            .edition
            {
                display: none;

                margin-top: 6vw;

                .OnDesktop({ margin: 5vh 3vh 1vh 3vh; });

                .vue-editor
                {
                    margin-top: 4vw;

                    .OnDesktop({
                        margin-top: 3vh;
                        margin-bottom: 4vh;
                    });

                    .ql-editor
                    {
                        min-height: 100px;
                    }
                }

                .button
                {
                    width: 100%;
                    margin-top: 4vw;

                    .OnDesktop({ margin-top: 1vh; });
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/EditUsefulInfo.vue